/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "._4t3i53f4{height:75pt}";
const _7 = "._2rkopxbi{border-radius:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Skeleton } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_IDS } from './testIds';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _6 = "._4t3i124j{height:324px}";
const _5 = "._4t3intd2{height:184px}";
const _4 = "._4t3imhvn{height:148px}";
const _3 = "._p12f1lk4{max-width:520px}";
const _2 = "._2rko1j6v{border-radius:1rem}";
export const AppTileSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
const AppTileSkeletonCompact = null;
export const AppTileSkeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko1j6v _p12f1lk4", __cmplp.size === AppTileSize.SMALL ? "_4t3imhvn" : __cmplp.size === AppTileSize.MEDIUM ? "_4t3intd2" : "_4t3i124j", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileSkeleton.displayName = 'AppTileSkeleton';
}
export const AppTileGridSkeleton = _ref2 => {
  let {
    tileCount = 6,
    size = AppTileSize.LARGE
  } = _ref2;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from({
      length: tileCount
    }, (_, index) => /*#__PURE__*/_jsx(AppTileSkeleton, {
      "data-testid": TEST_IDS.APP_TILE_SKELETON,
      size: size
    }, index))
  });
};
export const AppTileGridSkeletonCompact = _ref3 => {
  let {
    tileCount = 12
  } = _ref3;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from({
      length: tileCount
    }, (_, index) => /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_7, _3, _8]
      }), /*#__PURE__*/_jsx(Skeleton, {
        "data-testid": TEST_IDS.APP_TILE_SKELETON_COMPACT,
        className: ax(["_2rkopxbi _p12f1lk4 _4t3i53f4"])
      }, index)]
    }, index))
  });
};